/**
 * Created by Karan variya on 22/12/2018.
 */

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { KeywordModel } from './KeywordModal';
import { Keywords } from './keywordModel';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class KeywordService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allKeyword(data): Promise<KeywordModel[]> {
        return this.httpmanagerService.HttpPost('skeyword/allkeyword', JSON.stringify(data), "").then(data => {

            return data.data;
        })
    }
    inKeyword(data): Promise<Keywords> {
        return this.httpmanagerService.HttpPost('skeyword', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    uKeyword(id, data): Promise<Keywords> {
        return this.httpmanagerService.HttpPut('skeyword', JSON.stringify(data), id).then(data => {
            return data;
        })
    }
    dKeyword(id): Promise<Keywords> {
        return this.httpmanagerService.HttpDelete('skeyword', id).then(data => {
            return data;
        })
    }
    iJsonKeyword(data): Promise<Keywords> {
        return this.httpmanagerService.HttpPost('skeyword/json', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/keyword/keyword.service.ts